import { createRouter, createWebHashHistory } from 'vue-router';

import LearningProducts from '@/components/learningProducts.vue';
import ProductInfo from '@/components/ProductInfo.vue';
import IndexPage from '@/components/IndexPage.vue';
import AboutVue from '@/components/AboutVue.vue';
import Work from '@/components/Work.vue'; 

const router = createRouter({
    // 3.1 通过 history 属性，指定路由的工作模式
    history: createWebHashHistory(),
    // 3.2 通过 routes 数组，指定路由规则
    // path 是 hash 地址，component 是要展示的组件
    routes: [
        {
            path: '/',
            component: IndexPage,
            name: 'index',
        },
        { 
            path: '/productInfo', 
            component: ProductInfo,
            name: 'productInfo' 
        },
        { 
            path: '/learningProducts', 
            component: LearningProducts,
            name: 'learningProducts' 
        },
        { 
            path: '/about', 
            component: AboutVue,
            name: 'about' 
        },
        { 
            path: '/work', 
            component: Work,
            name: 'work' 
        }
    ],
})

export default router;